import React, { useState } from 'react';
import DetailsPage from '../components/DetailsPage';

function CarReport() {
  // Sample data - replace with actual data from your backend
  const [carData] = useState([
    {
      registrationNo: 'MH12AB1234',
      driverName: 'John Doe',
      laborName: 'Mike Smith',
      noOfTrips: 5,
      date: '2024-03-15'
    },
    {
      registrationNo: 'MH12CD5678',
      driverName: 'Jane Smith',
      laborName: 'Tom Brown',
      noOfTrips: 3,
      date: '2024-03-16'
    },
    // Add more sample data as needed
  ]);

  const columns = [
    { header: 'Car Registration No', field: 'registrationNo' },
    { header: 'Driver Name', field: 'driverName' },
    { header: 'Labor Name', field: 'laborName' },
    { header: 'No of Trips', field: 'noOfTrips' },
    { header: 'Date', field: 'date' }
  ];

  const handleRowClick = (row) => {
    // Handle row click if needed
    console.log('Row clicked:', row);
  };

  return (
    <DetailsPage
      title="Car Report"
      backPath="/dashboard"
      columns={columns}
      data={carData}
      onRowClick={handleRowClick}
      showTotalAmount={false} // This will hide the total amount section
    />
  );
}

export default CarReport; 